/** People Landing — editor de bloques. Hasta el 21/09/2026 vivía en BlockEditorDialog.tsx (1.017 líneas). */
import { type LandingBlock, type LandingBlockType } from '../../../../../shared/types/people-landing';

export const emptyDraftFor = (type: LandingBlockType): Partial<LandingBlock> & { type: LandingBlockType } => {
  switch (type) {
    case 'hero':
      return { type, title: '' };
    case 'richtext':
      return { type, markdown: '' } as any;
    case 'image':
      return { type } as any;
    case 'cards':
      return { type, columns: 3, items: [] } as any;
    case 'links':
      return { type, items: [] } as any;
    case 'embed':
      return { type, url: '' } as any;
    case 'divider':
      return { type } as any;
    case 'callout':
      return { type, title: '', tone: 'purple' } as any;
    case 'team':
    case 'progress':
    case 'news':
    case 'video':
      return { type } as any;
    case 'marquee':
      return { type, imageKeys: [] } as any;
  }
};
